export default __webpack_public_path__ + "static/media/35.541a158f.svg";